import { Reducer } from 'redux';

import * as types from './boards.types';
import * as constants from './boards.constants';

const initialState: types.FilterTasks = {
  inputValue: '',
  date: null,
  memberIds: [],
};

export const filterReducer: Reducer<types.FilterTasks> = (state = initialState, action) => {
  if (action.type === constants.FILTER_TASKS_FREETEXT) {
    return {
      ...state,
      inputValue: action.payload,
    };
  }
  if (action.type === constants.FILTER_TASKS_BY_DUE_DATE) {
    return {
      ...state,
      date: action.payload,
    };
  }
  if (action.type === constants.FILTER_TASKS_BY_MEMBER_IDS) {
    return {
      ...state,
      memberIds: action.payload,
    };
  } else {
    return {
      ...state,
    };
  }
};
